export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const SHIP_GROUPS_UPDATED = "SHIP_GROUPS_UPDATED";
export const ACCOUNT_MENU_CHANGED = "ACCOUNT_MENU_CHANGED";
export const CONTENT_COMPONENT_CHANGED = "CONTENT_COMPONENT_CHANGED";
export const SETTINGS_MENU_CHANGED = "SETTINGS_MENU_CHANGED";